/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function() {

  let activeChildMenu = null;
  let activeHandle = '';
  let activeV2Handle = '';
  const childMenuListWrapper = document.querySelector('.child-menu-list');
  if(childMenuListWrapper) {
    const closeChildMenu = ({menuEl,isTemp,opening}) => {
      if(menuEl instanceof HTMLElement) {
        if(opening) {
          menuEl.style.transition = 'none';
          menuEl.classList.remove('show');
          menuEl.style.transition = '';
        } else {
          menuEl.classList.remove('show');
        }
        if(!isTemp) {
          activeHandle = handle = null;
        }
      }
    }
    childMenuListWrapper.querySelectorAll('.child-menu').forEach(childMenu=>{
      childMenu.addEventListener('mouseleave',()=>{
        closeChildMenu({menuEl: childMenu});
      });
    });
    document.querySelectorAll('.l-headerDrawerDk__inner--lv3').forEach(subMenu=>{
      subMenu.addEventListener('mousemove',(e)=>{
        if(e.target.closest('li.l-headerDrawerDk__item--lv3')) {
          const handle = e.target.getAttribute('handle');
          if(activeHandle === handle) {
            return;
          }
          activeHandle = handle;
          closeChildMenu({menuEl: activeChildMenu,isTemp: true})
          if(handle !== '') {
            activeChildMenu = childMenuListWrapper.querySelector(`.child-menu[handle="${handle}"]`);
            if(activeChildMenu) {
              activeChildMenu.classList.add('show');
            }
          }
        }
      });
    });
    document.querySelector('.l-headerDrawerDk__container')?.addEventListener('mousemove',(e)=>{
      if(!e.target.closest('.l-headerDrawerDk__inner')) {
        closeChildMenu({menuEl: activeChildMenu, isTemp: false});
      }
    });
    document.addEventListener('close:header-menu-drawer',()=>{
      closeChildMenu({menuEl: activeChildMenu, isTemp: false,opening: false});
    });
    document.addEventListener('open:header-menu-drawer',()=>{
      closeChildMenu({menuEl: activeChildMenu, isTemp: false,opening: true});
    });
    document.addEventListener('change:actived-v2-link',(e)=>{
      if(activeV2Handle !== e.detail.handle) {
        activeV2Handle = e.detail.handle;
        closeChildMenu({menuEl: activeChildMenu,isTemp: false, opening: false});
      }
    });
  }
});